import { useAPIQuery, AlphabetsDraftApi } from "melco-shared-logic";

export const useFontsDropdown = () => {
  return useAPIQuery(
    AlphabetsDraftApi,
    ["fontsDropdownData"],
    async (api) => {
      const response = await api.userAlphabetSearch({
        offset: 0,
        limit: 100,
        sortBy: "name.asc",
        publishState: "published",
        service: "embroidery",
      });

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
